import React from "react";
import { IconDotsHorizontal } from "../../../base/icons/svg";
import Button from "../../../base/ui/components/web/Button";
import { BUTTON_TYPES } from "../../../base/ui/constants.any";
const ParticipantActionEllipsis = ({ accessibilityLabel, onClick, participantID }) => (React.createElement(Button, { accessibilityLabel: accessibilityLabel, icon: IconDotsHorizontal, onClick: onClick, size: "small", type: BUTTON_TYPES.Transparent, noBorder: true, testId: participantID ? `participant-more-options-${participantID}` : undefined }));
export default ParticipantActionEllipsis;
